import { ThemeProvider, createTheme } from '@mui/material/styles';
import {
    HashRouter as Router,
    Route,
    Routes
} from "react-router-dom";
import './App.css';
import AppContainer from './components/AppContainer';
import HistoryPage from './pages/HistoryPage';
import ListPollPage from './pages/ListPollPage';
import CreatePollPage from './pages/CreatePollPage';
import { CreatePollProvider } from './context/CreatePollContextProvider';
import { UserContextProvider } from './context/UserContextProvider';
import ManagePollPage from './pages/ManagePollPage';
import { AppBarContextProvider } from './context/AppBarContextProvider';
import ViewPollPage from './pages/ViewPollPage';
import { TangledContextProvider } from './context/TangledContextProvider';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';


const theme = createTheme({
    palette: {
        mode: 'dark',
    },
});

function App() {
    return (
        <ThemeProvider theme={theme}>
            <TangledContextProvider>
                <UserContextProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Router>
                            <Routes>
                                <Route path="/view/:id" element={<ViewPollPage />} />
                                <Route path="/" element={<AppBarContextProvider><AppContainer /></AppBarContextProvider>}>
                                    <Route index element={<ListPollPage />} />
                                    <Route path="create-poll" element={<CreatePollProvider><CreatePollPage /></CreatePollProvider>} />
                                    <Route path="poll/:id" element={<ManagePollPage />} />
                                    <Route path="history" element={<HistoryPage />} />
                                </Route>
                            </Routes>
                        </Router>
                    </LocalizationProvider>
                </UserContextProvider>
            </TangledContextProvider>
        </ThemeProvider>
    );
}

export default App;
